import React from 'react';
import { FaGithub, FaInfoCircle, FaExternalLinkAlt, FaFolderOpen } from 'react-icons/fa';
import SectionTitle from '../components/shared/SectionTitle';
import '../styles/projects.css';

const projects = [
  {
    num: '01',
    title: 'XYZ Retail Company Sales Analysis',
    description: 'Analysed sales data to generate actionable insights for XYZ Retail Company. Cleaned, processed, and visualised the dataset in Microsoft Excel — producing a dashboard that highlights revenue trends, top products, and regional performance gaps.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80&fit=crop',
    tags: ['Sales Analysis', 'Dashboard', 'Data Cleaning'],
    tools: 'Microsoft Excel',
    github: 'https://github.com/Hardy999',
    live: null,
  },
  {
    num: '02',
    title: 'Data Dig — Advanced SQL Queries',
    description: 'Leveraged advanced SQL SELECT queries to extract actionable insights from complex relational datasets. Developed targeted queries addressing specific business questions — improving analytical decision speed by 30%.',
    image: 'https://images.unsplash.com/photo-1544383835-bda2bc66a55d?w=800&q=80&fit=crop',
    tags: ['SQL', 'Business Intelligence', 'Data Extraction'],
    tools: 'SQL · PostgreSQL',
    github: 'https://github.com/Hardy999',
    live: null,
  },
  {
    num: '03',
    title: 'Book Drive Logistics Data System',
    description: 'Built a data tracking and reporting system to manage two shipping containers annually, supporting 30–60 libraries. Monitored capacity, deadlines, and shipment status — reducing shipping delays by 20%.',
    image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80&fit=crop',
    tags: ['Logistics', 'Data Management', 'Operations'],
    tools: 'Excel · Salesforce CRM',
    github: null,
    live: null,
  },
  {
    num: '04',
    title: 'Community Water Needs Survey Analysis',
    description: 'Designed and implemented a household water-access survey across 25+ homes in Tamale. Analysed data to identify gaps and produced a proposal for poly tank storage solutions — impacting 30% of local households.',
    image: 'https://images.unsplash.com/photo-1555685812-4b943f1cb0eb?w=800&q=80&fit=crop',
    tags: ['Survey Design', 'Community Data', 'Policy Analysis'],
    tools: 'Python · Google Sheets',
    github: null,
    live: null,
  },
];

function Projects() {
  return (
    <section className="projects section" id="projects">
      <div className="container">
        <SectionTitle label="What I've Built" title="Notable Projects" />
        {projects.map((project) => (
          <div className="project-block" key={project.num}>
            <span className="project-block__number">{project.num}</span>
            <div className="project-block__image">
              <img src={project.image} alt={project.title} />
            </div>
            <div className="project-block__content">
              <div className="project-block__tags">
                {project.tags.map((t) => <span className="tag" key={t}>{t}</span>)}
              </div>
              <h3 className="project-block__title">{project.title}</h3>
              <p className="project-block__description">{project.description}</p>
              <p className="project-block__tools"><strong>Tools: </strong>{project.tools}</p>
              <div className="project-block__links">
                {project.github && (
                  <a href={project.github} target="_blank" rel="noopener noreferrer">
                    <FaGithub /> GitHub
                  </a>
                )}
                {project.live && (
                  <a href={project.live} target="_blank" rel="noopener noreferrer">
                    <FaExternalLinkAlt /> Live Demo
                  </a>
                )}
                <a href="/contact"><FaInfoCircle /> Learn More</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;